"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ScrollableList = _interopRequireDefault(require("./ScrollableList"));

var _Lightbox = _interopRequireDefault(require("./Lightbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MediaAttachments = function MediaAttachments(_ref) {
  var media = _ref.media,
      showLabel = _ref.showLabel;

  var _useState = (0, _react.useState)(1),
      selectedMedia = _useState[0],
      setSelectedMedia = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      lightboxIsOpen = _useState2[0],
      setLightboxIsOpen = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", null, media && media.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingLeft: 1
    }
  }, showLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "ln-c-label"
  }, "Media Attachments (", media.length, " total)"), /*#__PURE__*/_react.default.createElement(_ScrollableList.default, {
    media: media,
    onMediaClicked: function onMediaClicked(option) {
      setSelectedMedia(media.filter(function (m) {
        return m.type === 'image';
      }).indexOf(option));
      setLightboxIsOpen(true);
    }
  }), /*#__PURE__*/_react.default.createElement(_Lightbox.default, {
    media: media.map(function (m) {
      return {
        imageUrl: m.url,
        imageTitle: m.fileName,
        imageDescription: m.description,
        type: m.type
      };
    }),
    selection: selectedMedia,
    open: lightboxIsOpen,
    onClose: function onClose() {
      return setLightboxIsOpen(false);
    }
  })));
};

MediaAttachments.propTypes = {
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    fileName: _propTypes.default.string.isRequired,
    description: _propTypes.default.string,
    type: _propTypes.default.string,
    url: _propTypes.default.string.isRequired
  })),
  showLabel: _propTypes.default.bool
};
MediaAttachments.defaultProps = {
  media: [],
  showLabel: true
};
var _default = MediaAttachments;
exports.default = _default;